import * as React from "react";

export function CrossfitTableBodyRow(props: { children: React.ReactNode }): JSX.Element {
    return <tr>{props.children}</tr>;
}
